import React from 'react'
import { useEffect } from 'react'
import { useState } from 'react'

const ChangeType = ({ type }) => {

    const [typeText, setTypeText] = useState(null)

    useEffect(() => {
        changeTypeText()
    }, [type])

    const changeTypeText = () => {
        let text = ''

        if (type) {
            if (type === 'add') {
                text = 'Додано'
            } else if (type === 'update') {
                text = 'Оновлено'
            } else if (type === 'delete') {
                text = 'Видалено'
            }
        }

        const divBlock = <div className={`changesBlock__one-status changesBlock__one-status-${type}`}>{text}</div>

        setTypeText(divBlock)
    }
    
  return (
    <div>
        {
            typeText 
        }
    </div>
  )
}

export default ChangeType